import React from "react";
import axios from "axios";
import Conf from "./Conf";
import Navbar from "./components/Navbar";
import CancelDialog from "./components/CancelDialog";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import PageHead from "./components/PageHead";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import { goLogin, getPermission, getStampTime } from "./js/main";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Link } from "react-router-dom";

import { Fragment } from "react";
import IconButton from "@material-ui/core/IconButton";
import CancelIcon from "@material-ui/icons/Cancel";
import CreateIcon from "@material-ui/icons/Create";

import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Button from "@material-ui/core/Button";
import AssessmentIcon from "@material-ui/icons/Assessment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

const current_path = Conf.frontendURL + "report";
const page_title = "รายงานใบแจ้งหนี้";
export default class Report extends React.Component {
  state = {
    cookie: null,
    form: {
      skip: 0,
      startDate: new Date(),
      endDate: new Date(),
    },
    limit: 50,
    count: 0,
    pages: [],
    summation: {
      amount: 0,
      cash_amount: 0,
      tranfer_amount: 0,
      cancel_amount: 0,
      billers: [],
    },
    selected_operator: null,
    open_dialog: false,
    showAll: false,
  };
  componentDidMount() {
    this.getAuth();
  }
  async getAuth() {
    var cookie = localStorage.getItem(Conf.cookieName);
    cookie = JSON.parse(cookie);
    if (cookie && cookie.token) {
      var auth = await getPermission(cookie.token);
      var result = await this.getResult(auth.profile);
      if (auth === false) goLogin(current_path);
      else
        this.setState({
          profile: auth.profile,
          cookie: cookie,
          pages: result.pages,
          count: result.count,
          result: result.invoices,
          summation: result.summation,
          facet: result.facet,
        });
    } else goLogin(current_path);
  }
  getResult(auth, pageLimit) {
    return new Promise(async (resolve) => {
      var { form, limit, selected_operator, showAll, profile } = this.state;
      var Profile = profile;
      if (!pageLimit) pageLimit = limit;
      if (auth) Profile = auth;
      var startDate = await getStampTime(form.startDate);
      var endDate = await getStampTime(form.endDate);
      var query = {
        $and: [
          { create_date: { $gte: startDate.iso_date } },
          { create_date: { $lte: endDate.iso_date } },
          // { "bills.transactionDateandTime": { $gte: startDate.iso_date } },
          // { "bills.transactionDateandTime": { $lte: endDate.iso_date } },
          // { "bills.transactionDateandTime": "2021-03-18T15:01:57.405+07:00" },
        ],
      };
      if (showAll === false) {
        // query["$and"].push({ "bills.operator.usn": selected_operator });
        query["$and"].push({ "bills.operator.usn": Profile.usn });
      } else if (selected_operator !== null) {
        query["$and"].push({ "bills.operator.usn": selected_operator });
      }
      var cookie = localStorage.getItem(Conf.cookieName);
      cookie = JSON.parse(cookie);
      axios
        .post(
          Conf.digitalpayBackend + "invoice",
          {
            skip: form.skip,
            query: query,
            facet: true,
            limit: pageLimit,
          },
          { headers: { Authorization: cookie.token } }
        )
        .then(async (res) => {
          var result = [];
          var facet = res.data.facet;
          /*
          var summation = {
            amount: 0,
            cash_amount: 0,
            tranfer_amount: 0,
            cancel_amount: 0,
            billers: [],
          };
          */
          var summation = res.data.summation;
          if (res.data.invoices) {
            result = await res.data.invoices.map((bill, key) => {
              bill.rowSpan = bill.bills.length > 0 ? bill.bills.length : 1;
              bill.no = form.skip + key + 1;
              /*
              for (let b of bill.bills) {
                if (!b.canceled || b.canceled.status === false) {
                  let amount = parseFloat(b.amount);
                  if (b.transactionType === "Pay by Cash")
                    summation.cash_amount += amount;
                  else summation.tranfer_amount += amount;

                  for (let detail of bill.details) {
                    let i = summation.billers.findIndex(
                      (j) =>
                        j.account_code === detail.account_code &&
                        j.biller_name === detail.biller_name
                    );
                    if (i < 0) {
                      summation.billers.push({
                        account_code: detail.account_code,
                        biller_name: detail.biller_name,
                        amount: detail.amount,
                      });
                    } else summation.billers[i].amount += detail.amount;
                  }
                } else summation.cancel_amount++;
              }
              */
              return bill;
            });
          }
          //summation.amount = summation.cash_amount + summation.tranfer_amount;
          var pages = [];
          for (let i = 0, no = 1; i < res.data.count; i += pageLimit, no++) {
            pages.push({ no: no, skip: i });
          }
          resolve({
            pages: pages,
            count: res.data.count,
            invoices: result,
            summation: summation,
            facet,
          });
        });
    });
  }
  changeShowAll(e) {
    var chk = e.target.checked;
    this.setState(
      {
        showAll: chk,
      },
      async () => {
        var result = await this.getResult();
        this.setState({
          pages: result.pages,
          count: result.count,
          result: result.invoices,
          facet: result.facet,
          summation: result.summation,
        });
      }
    );
    // changeShowAll
  }
  changeOperator(usn) {
    var { selected_operator } = this.state;
    if (selected_operator === usn) usn = null;
    this.setState({ selected_operator: usn }, async () => {
      var result = await this.getResult();
      this.setState({
        pages: result.pages,
        count: result.count,
        result: result.invoices,
        facet: result.facet,
        summation: result.summation,
      });
    });
  }
  async changeDate(date, id) {
    var { form } = this.state;
    form[id] = date;
    form.skip = 0;
    this.setState({ form }, async () => {
      var result = await this.getResult();
      this.setState({
        pages: result.pages,
        count: result.count,
        result: result.invoices,
        facet: result.facet,
        summation: result.summation,
        selected_operator: null,
      });
    });
  }
  goPage(skip) {
    var { form } = this.state;
    form.skip = skip;
    this.setState({ form }, async () => {
      var result = await this.getResult();
      this.setState({
        pages: result.pages,
        count: result.count,
        result: result.invoices,
        summation: result.summation,
        facet: result.facet,
      });
    });
  }
  confirmCancel(txt) {
    var id = this.state.cancel_bill._id;
    // if (window.confirm("Confirm to cancel")) {
    var cookie = localStorage.getItem(Conf.cookieName);
    cookie = JSON.parse(cookie);
    if (cookie && cookie.token) {
      axios
        .post(
          Conf.digitalpayBackend + "bill/delete",
          {
            _id: id,
            remark: txt,
          },
          {
            headers: { Authorization: cookie.token },
          }
        )
        .then(async (res) => {
          var bill = res.data;
          if (bill && bill.canceled && bill.canceled.status === true) {
            var { result } = this.state;
            var key = 0;
            for (let invoice of result) {
              let i = invoice.bills.findIndex((j) => j._id === id);
              if (i > -1) {
                result[key].bills[i].canceled = bill.canceled;
              }
              key++;
            }
            this.setState(
              { result, open_dialog: false } /* , () => {
              this.props.history.push(
                process.env.PUBLIC_URL + "/replace/" + id
              );
            } */
            );
          }
        });
    } else goLogin();
    // }
  }
  cancelBill(status, bill) {
    this.setState({ open_dialog: status, cancel_bill: bill });
  }
  btnOperatorStyle(usn) {
    var { selected_operator } = this.state;
    var color = "#ccc";
    if (selected_operator === usn) color = "#3f50b5";
    return { color: color, marginRight: "5px" };
  }
  render() {
    const {
      profile,
      form,
      result,
      count,
      pages,
      summation,
      // facet,
      open_dialog,
      showAll,
      cancel_bill,
    } = this.state;
    return (
      <div>
        {profile && (
          <>
            <Navbar />
            <main className="content">
              <PageHead
                icon={<AssessmentIcon style={{ fontSize: "2rem" }} />}
                title={page_title}
                profile={profile}
              />
              <PickDate
                changeDate={(date, id) => this.changeDate(date, id)}
                startDate={form.startDate}
                endDate={form.endDate}
              />
              {/* <br />
              <div>
                {facet &&
                  facet.operators.map((operator, key) => (
                    <Button
                      key={key}
                      variant="outlined"
                      size="small"
                      color="inherit"
                      style={this.btnOperatorStyle(operator.usn)}
                      onClick={() => this.changeOperator(operator.usn)}
                    >
                      {operator.usn}
                    </Button>
                  ))}
              </div> */}
              <br />
              <PageLink
                goPage={(skip) => this.goPage(skip)}
                form={form}
                pages={pages}
              />
              <CancelDialog
                open={open_dialog}
                cancel_id={cancel_bill}
                onCloseDialog={() => this.cancelBill(false)}
                confirmCancel={(txt) => this.confirmCancel(txt)}
              />
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <div style={{ lineHeight: "50px" }}>
                    <span style={{ fontWeight: 500, marginRight: "10px" }}>
                      Count :{" "}
                    </span>
                    {count} Invoice(s)
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} align="right">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showAll}
                        onChange={(e) => this.changeShowAll(e)}
                        name="showAll"
                        color="primary"
                      />
                    }
                    label="แสดงทั้งหมด"
                  />
                </Grid>
              </Grid>
              <ReportTable
                result={result}
                onCancel={(id) => this.cancelBill(true, id)}
              />
              <br />
              <SummationReport summation={summation} />
            </main>
          </>
        )}
      </div>
    );
  }
}
class SummationReport extends React.Component {
  render() {
    var { summation } = this.props;
    return (
      <div>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={6}>
            <TableContainer component={Paper}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell
                      scope="row"
                      colSpan={3}
                      style={{
                        fontSize: "1.2rem",
                        textAlign: "left",
                      }}
                    >
                      ยอดเงิน
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      รวมเป็นเงิน
                    </TableCell>
                    <TableCell align="right" style={{ width: "150px" }}>
                      {summation.amount.toLocaleString()}
                    </TableCell>
                    <TableCell style={{ width: "100px" }}>บาท</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      เงินสด
                    </TableCell>
                    <TableCell align="right">
                      {summation.cash_amount.toLocaleString()}
                    </TableCell>
                    <TableCell>บาท</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      เงินโอน
                    </TableCell>
                    <TableCell align="right">
                      {summation.tranfer_amount.toLocaleString()}
                    </TableCell>
                    <TableCell>บาท</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      รายการยกเลิก
                    </TableCell>
                    <TableCell align="right">
                      {summation.cancel_amount.toLocaleString()}
                    </TableCell>
                    <TableCell>รายการ</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12} lg={6}>
            <TableContainer component={Paper}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell
                      scope="row"
                      colSpan={3}
                      style={{
                        fontSize: "1.2rem",
                        textAlign: "left",
                      }}
                      align="left"
                    >
                      ประเภทรายได้
                    </TableCell>
                  </TableRow>
                  {summation.billers.map((bill, key) => (
                    <TableRow key={key}>
                      <TableCell>{bill.biller_name}</TableCell>
                      <TableCell align="right">
                        {bill.amount.toLocaleString()}
                      </TableCell>
                      <TableCell>บาท</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </div>
    );
  }
}

class PickDate extends React.Component {
  render() {
    const { changeDate, startDate, endDate } = this.props;

    return (
      <div>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid container>
            <Grid item style={{ paddingRight: "20px" }}>
              <KeyboardDatePicker
                margin="normal"
                id="startDate"
                label="From"
                autoOk
                format="yyyy-MM-dd"
                value={startDate}
                onChange={(date) => changeDate(date, "startDate")}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </Grid>
            <Grid item>
              <KeyboardDatePicker
                margin="normal"
                id="endDate"
                label="To"
                autoOk
                format="yyyy-MM-dd"
                value={endDate}
                onChange={(date) => changeDate(date, "endDate")}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </Grid>
          </Grid>
        </MuiPickersUtilsProvider>
      </div>
    );
  }
}

class ReportTable extends React.Component {
  render() {
    const { result, onCancel } = this.props;
    const styles = {
      cell: {
        padding: "5px 3px",
        fontSize: ".7rem",
      },
      centerCell: {
        padding: "5px 3px",
        textAlign: "center",
        fontSize: ".7rem",
      },
    };
    return (
      <div>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>No</TableCell>
                <TableCell>Invoice No</TableCell>
                {/* <TableCell>Barcode</TableCell> */}
                <TableCell>ชื่อ-สกุล</TableCell>
                <TableCell>จำนวนเงิน</TableCell>
                <TableCell>ประเภทรายได้</TableCell>
                <TableCell>เลขที่ใบเสร็จ</TableCell>
                <TableCell>การรับเงิน</TableCell>
                <TableCell>Transaction</TableCell>
                <TableCell>Date/Time</TableCell>
                <TableCell>จำนวนเงิน</TableCell>
                <TableCell>ผู้ดำเนินการ</TableCell>
                <TableCell>ยกเลิกใบเสร็จ</TableCell>
                <TableCell>ออกใบเสร็จใหม่</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {result.map((invoice, key) => (
                <Fragment key={key}>
                  <TableRow>
                    <TableCell
                      style={styles.centerCell}
                      rowSpan={invoice.rowSpan}
                    >
                      {invoice.no}
                    </TableCell>
                    <TableCell
                      style={styles.centerCell}
                      rowSpan={invoice.rowSpan}
                    >
                      {invoice.invoice_id}
                    </TableCell>
                    {/* <TableCell rowSpan={invoice.rowSpan}></TableCell> */}
                    <TableCell style={styles.cell} rowSpan={invoice.rowSpan}>
                      {invoice.debtor_name}
                    </TableCell>
                    <TableCell
                      style={styles.centerCell}
                      rowSpan={invoice.rowSpan}
                    >
                      {invoice.amount}
                    </TableCell>
                    <TableCell style={styles.cell} rowSpan={invoice.rowSpan}>
                      {invoice.details &&
                        invoice.details.map((detail, key) => (
                          <div key={key} style={{ marginBottom: "3px" }}>
                            {detail.biller_name}
                          </div>
                        ))}
                    </TableCell>
                    <BillCell
                      bill={invoice.bills[0]}
                      onCancel={() => onCancel(invoice.bills[0])}
                    />
                  </TableRow>
                  {invoice.bills.length > 1 &&
                    invoice.bills.map((bill, key) => (
                      <Fragment key={key}>
                        {key > 0 && (
                          <TableRow key={key}>
                            <BillCell
                              bill={bill}
                              onCancel={() => onCancel(bill)}
                            />
                          </TableRow>
                        )}
                      </Fragment>
                    ))}
                </Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  }
}

class BillCell extends React.Component {
  render() {
    const styles = {
      cell: {
        padding: "5px 3px",
        fontSize: ".7rem",
      },
      centerCell: {
        padding: "5px 3px",
        textAlign: "center",
        fontSize: ".7rem",
      },
    };
    const { bill, onCancel } = this.props;
    return (
      <>
        {bill ? (
          <>
            <TableCell style={styles.centerCell}>
              <a href={`${Conf.frontendURL}bill/${bill.bill_id}`}>
                {bill.bill_id}
              </a>
            </TableCell>
            <TableCell style={styles.centerCell}>
              {bill.transactionType === "Pay by Cash" ? "CASH" : "TRANFER"}
            </TableCell>
            <TableCell style={styles.centerCell}>
              {bill.transactionId}
            </TableCell>
            <TableCell style={styles.centerCell}>
              {bill.transactionDateandTime}
            </TableCell>
            <TableCell style={styles.centerCell}>{bill.amount}</TableCell>
            <TableCell style={styles.centerCell}>
              {bill.operator && bill.operator.usn}
            </TableCell>
            <TableCell style={styles.centerCell}>
              {!bill.canceled || bill.canceled.status === false ? (
                <IconButton
                  color="secondary"
                  aria-label="upload picture"
                  component="span"
                  style={{ padding: "3px 3px" }}
                  onClick={() => onCancel(bill._id)}
                >
                  <CancelIcon />
                </IconButton>
              ) : (
                <>
                  <div>{bill.canceled.usn}</div>
                  <div>{bill.canceled.remark}</div>
                </>
              )}
            </TableCell>
            <TableCell style={styles.centerCell}>
              {bill.canceled && bill.canceled.status === true && (
                <>
                  {bill.canceled.new_bill ? (
                    <>{bill.canceled.new_bill_no}</>
                  ) : (
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component={Link}
                      style={{ padding: "3px 3px" }}
                      // to={`${process.env.PUBLIC_URL}/newbill/${bill._id}`}
                      to={`${process.env.PUBLIC_URL}/replace/${bill.bill_id}`}
                    >
                      <CreateIcon />
                    </IconButton>
                  )}
                </>
              )}
            </TableCell>
          </>
        ) : (
          <TableCell colSpan={8}></TableCell>
        )}
      </>
    );
  }
}

class PageLink extends React.Component {
  render() {
    const { form, pages } = this.props;
    return (
      <Breadcrumbs aria-label="breadcrumb" separator="">
        <span>Pages : </span>
        {pages.map((page, key) => (
          <div key={key}>
            {form.skip === page.skip ? (
              <span style={{ fontWeight: "400", color: "#900" }}>
                {page.no}
              </span>
            ) : (
              <Button
                key={page.no}
                color="inherit"
                style={{ padding: "3px 3px", minWidth: "20px" }}
                onClick={() => this.props.goPage(page.skip)}
              >
                {page.no}
              </Button>
            )}
          </div>
        ))}
      </Breadcrumbs>
    );
  }
}
